import React from 'react';
import { isBrowser } from 'ws-scripts/modules/environment';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { removeVehicle } from '../../features/vehicles';

const RemoveButton = ({ uuid }) => {
	const dispatch = useDispatch();
	let currentUrlCompare = null;
	let vehicleIds = [];
	if (isBrowser) {
		currentUrlCompare = new URL(window.location);
		const vehicleIdsParams =
			currentUrlCompare?.searchParams?.get('itemIds') || '';
		vehicleIds = vehicleIdsParams.split(',');
	}

	const handleRemoveVehicle = () => {
		dispatch(removeVehicle(uuid));
		const remainingVehicleIds = vehicleIds.filter((id) => id !== uuid);
		currentUrlCompare.searchParams.set('itemIds', remainingVehicleIds);

		if (isBrowser) {
			window.history.pushState({}, '', currentUrlCompare.href);

			// AC3: Remove UUID from sessionStorage on vehicle removal
			try {
				const stored = sessionStorage.getItem(
					'DDC.inventory-compare.selected'
				);
				if (stored) {
					const updatedUuids = stored
						.split(',')
						.filter((id) => id && id !== uuid);
					if (updatedUuids.length > 0) {
						sessionStorage.setItem(
							'DDC.inventory-compare.selected',
							updatedUuids.join(',')
						);
					} else {
						sessionStorage.removeItem(
							'DDC.inventory-compare.selected'
						);
					}
				}
			} catch (e) {
				// fail silently on SecurityError / quota exceeded
			}

			// Trigger calculate vehicleCardWidth after vehicle remove
			setTimeout(() => window.dispatchEvent(new Event('resize')), 0);
		}
	};

	return (
		<button
			type="button"
			className="close"
			aria-label="remove vehicle"
			onClick={handleRemoveVehicle}
		>
			<i
				className="ddc-icon ddc-icon-remove2 ddc-icon-size-small"
				aria-hidden="true"
			/>
		</button>
	);
};

RemoveButton.propTypes = {
	uuid: PropTypes.string.isRequired
};

export default RemoveButton;
